export function escapeHtml(str) {
  if (str == null) return ''
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function safeUrl(url) {
  if (!url || typeof url !== 'string') return ''
  try {
    const parsed = new URL(url, 'https://placeholder')
    if (parsed.protocol === 'https:' || parsed.protocol === 'http:' || url.startsWith('/')) return escapeHtml(url)
    return ''
  } catch { return '' }
}

export function cls(...args) {
  return args.filter(Boolean).join(' ')
}

export function truncate(str, n = 60) {
  if (!str) return ''
  return str.length > n ? str.slice(0, n) + '…' : str
}

export function plural(n, singular, pluralForm) {
  return `${n} ${n === 1 ? singular : (pluralForm || singular + 's')}`
}

export function fmtAssetId(assetId, deptCode) {
  if (!assetId) return null
  const num = String(assetId).padStart(4, '0')
  return deptCode ? `${deptCode}-${num}` : `#${num}`
}
